import { useState, useRef, useCallback } from 'react';

const API_URL = 'https://www.resursecrestine.ro/web-api-search';

export default function useVerseSearch() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const timerRef = useRef(null);
  const abortRef = useRef(null);

  const search = useCallback((text) => {
    setQuery(text);
    if (timerRef.current) clearTimeout(timerRef.current);
    if (abortRef.current) abortRef.current.abort();

    if (text.trim().length < 2) {
      setResults([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    timerRef.current = setTimeout(async () => {
      const controller = new AbortController();
      abortRef.current = controller;

      try {
        const params = new URLSearchParams({
          search_text: text.trim(),
          search_in: '16',
          search_by: 'filtru-titlu',
          output: 'json2',
        });

        const resp = await fetch(`${API_URL}?${params}`, { signal: controller.signal });
        if (!resp.ok) throw new Error('API error');

        const data = await resp.json();
        const verses = (data.Results || [])
          .filter((r) => r.kind === 'biblia')
          .map((r) => ({
            book: r.id,
            chapter: r.author,
            verse: r.slug,
            text: r.title,
            ref: `${r.id} ${r.author}:${r.slug}`,
          }));

        setResults(verses);
        setLoading(false);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err.message);
          setLoading(false);
        }
      }
    }, 300);
  }, []);

  const clear = useCallback(() => {
    setQuery('');
    setResults([]);
    setLoading(false);
    setError(null);
    if (timerRef.current) clearTimeout(timerRef.current);
    if (abortRef.current) abortRef.current.abort();
  }, []);

  return { query, results, loading, error, search, clear };
}
